<div style="width: 100%; text-align: center;">
    <div class="contentContainer" style="margin-top: 100px;">

        <DIV class="appLabel">Your current PIN</DIV>
        <input [(ngModel)]="req.currentpin" type="password" maxlength="6" class="appInput" name="txtCurrentPin" id="txtCurrentPin" 
            style="width: 100px;">
        <DIV class="appLabel">New PIN</DIV>
        <input type="password" maxlength="6" [(ngModel)]="req.newpin" class="appInput" name="txtNewPin" id="txtNewPin" style="width: 100px;">
        <DIV class="appLabel">Confirm PIN</DIV>
        <input type="password" maxlength="6" class="appInput" name="txtRepeatPin" id="txtRepeatPin" [(ngModel)]="this.confirmPin"
            style="width: 100px;">
        <div class="appButtonBar">
            <input type="submit" class="appButton" name="cmdSubmit" id="cmdSubmit" style="width: 100px;"
                (click)="onPinChangeSubmit()" value="Update PIN">
        </div>
        <div class="appLabel" style="color: red;">{{errMessage}}</div>
    </div>